import React, { FC } from 'react'
import {
  default as full_logo,
  default as full_logo_tm,
} from '../../../../../static-cdn/images/uipath-latest-logo-new.svg'
import {
  default as full_logo_mobile,
  default as full_logo_tm_mobile,
} from '../../../../../static-cdn/images/uipath-newlogo-mobile.svg'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { MenuNav } from '../../../../models/others/menuNav'
import ImgUtil from '../../../../utils/img.utils'
import { isExternalURL } from '../../../../utils/link.utils'
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import { ResponsiveIcon } from '../style'

type NavLogoProps = {
  uiPathSrc: string
  langCode: string
}

type NavButtonProps = {
  url: string
  text: string
}

type TopHatLinksProps = {
  headerData: MenuNav
}

type HamburgerIconProps = {
  openMenu: boolean
  setOpenMenu: (openMenu: boolean) => void
}

export const NavLogo: FC<NavLogoProps> = ({ uiPathSrc, langCode }) => (
  <a href={uiPathSrc} rel="noopener" className="Navbar__Logo">
    <img
      src={langCode !== LocaleCodes.CHINESE.code ? full_logo : full_logo_tm}
      alt="UiPath Logo"
      className="desktop__logo"
    />
    <img
      src={langCode !== LocaleCodes.CHINESE.code ? full_logo_mobile : full_logo_tm_mobile}
      alt="UiPath Logo"
      className="mobile__logo"
    />
  </a>
)

export const NavButton: FC<NavButtonProps> = ({ url, text }: any) => (
  <div className="Navbar__Main_Button">
    <Button type={'primary'} theme={'light'} href={url} text={text} size="small" />
  </div>
)

export const TopHatLinks: FC<TopHatLinksProps> = ({ headerData }) => (
  <ul className="Navbar__TopHatLinks_Wrapper">
    {headerData.topHatLinks?.map(({ id, ctaText, icon, url }: any, index: number) => {
      const target = isExternalURL(url) ? '_blank' : '_self'

      return (
        <li key={`${id}-${index}`}>
          <a href={url} target={target}>
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(icon?.image?.file?.url, '')}
              width={22}
              alt={icon?.altText}
            />

            <Typography type="bodyXS">{ctaText}</Typography>
          </a>
        </li>
      )
    })}
  </ul>
)

export const NavHamburgerIcon: FC<HamburgerIconProps> = ({ openMenu, setOpenMenu }: any) => {
  const openNavMenu = () => {
    if (openMenu) {
      setOpenMenu(false)
      document.body.style.overflow = 'auto' //* allows page to scroll
    } else {
      setOpenMenu(true)
      document.body.style.overflow = 'hidden' //* prevents page from scrolling
    }
  }

  return (
    <ResponsiveIcon $openMenu={openMenu} onClick={openNavMenu}>
      <div className="Navbar__Hamburger">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </ResponsiveIcon>
  )
}
